import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthUser, getValidToken } from '../utils/auth';

function PrivateRoute({ component: Component, requiredRole }) {
  const token = getValidToken();

  if (!token) {
    return <Navigate to="/login" />;
  }

  const user = getAuthUser();
  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/dashboard" />;
  }

  return <Component />;
}

export default PrivateRoute;
